import { mutationTypes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	[mutationTypes.DOCUMENTOS.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.DOCUMENTOS.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.DOCUMENTOS.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.DOCUMENTOS.SET_ID_ATA](state, idAta) {
		state.idAta = idAta
	},

	[mutationTypes.DOCUMENTOS.RESETAR_PAGINACAO_LISTAGEM](state) {
		state.paginacao = paginacaoListagem([], 25)
	},
}
